/**
 * Activity Row - TICKET ZKPVN1
 * 
 * Fila individual de actividad con acciones.
 */

import React from 'react';
import { Edit2, Trash2, ArrowUp, ArrowDown, Youtube, Link, FileText, Zap, FlaskConical } from 'lucide-react';

const ActivityRow = ({ 
  activity, 
  isFirst, 
  isLast, 
  onEdit, 
  onDelete, 
  onMoveUp, 
  onMoveDown 
}) => {
  // Icono según tipo
  const getIcon = () => {
    switch (activity.type) {
      case 'resource':
        if (activity.resource?.subtype === 'youtube') {
          return <Youtube className="w-4 h-4 text-red-500" />;
        } else if (activity.resource?.subtype === 'link') {
          return <Link className="w-4 h-4 text-blue-500" />;
        } else if (activity.resource?.subtype === 'text') {
          return <FileText className="w-4 h-4 text-gray-500" />;
        }
        return <FileText className="w-4 h-4 text-gray-500" />;
      case 'vrt_simulation':
        return <Zap className="w-4 h-4 text-purple-500" />;
      case 'epl_lab':
        return <FlaskConical className="w-4 h-4 text-cyan-500" />;
      default:
        return <FileText className="w-4 h-4 text-gray-500" />;
    }
  };

  // Badge de tipo
  const getTypeBadge = () => {
    const badges = {
      resource: 'Recurso',
      vrt_simulation: 'VRT Sim',
      epl_lab: 'EPL Lab'
    };

    const colors = {
      resource: 'bg-gray-100 text-gray-700',
      vrt_simulation: 'bg-purple-100 text-purple-700',
      epl_lab: 'bg-cyan-100 text-cyan-700'
    };

    return (
      <span className={`px-2 py-0.5 rounded text-xs font-medium ${colors[activity.type]}`}>
        {badges[activity.type]}
      </span>
    );
  };

  return (
    <div className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors">
      {/* Info de la actividad */}
      <div className="flex items-center gap-3 flex-1">
        {getIcon()}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h5 className="font-medium text-gray-900 truncate">{activity.title}</h5>
            {getTypeBadge()}
          </div>
          <div className="flex items-center gap-3 mt-1">
            <span className="text-xs text-gray-500">
              {activity.estimatedMinutes} min
            </span>
            <span className="text-xs text-gray-400">•</span>
            <span className="text-xs text-gray-500">
              ID: {activity.activityId}
            </span>
            {activity.type === 'resource' && activity.resource?.subtype === 'youtube' && (
              <>
                <span className="text-xs text-gray-400">•</span>
                <a
                  href={activity.resource.youtubeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-blue-600 hover:underline flex items-center gap-1"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Youtube className="w-3 h-3" />
                  Ver video
                </a>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Acciones */}
      <div className="flex items-center gap-1 ml-4">
        {/* Reorden */}
        <button
          onClick={onMoveUp}
          disabled={isFirst}
          className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
          title="Subir"
        >
          <ArrowUp className="w-3.5 h-3.5" />
        </button>
        <button
          onClick={onMoveDown}
          disabled={isLast}
          className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
          title="Bajar"
        >
          <ArrowDown className="w-3.5 h-3.5" />
        </button>

        {/* Editar */}
        <button
          onClick={onEdit}
          className="p-1.5 text-blue-600 hover:bg-blue-50 rounded transition-colors"
          title="Editar"
        >
          <Edit2 className="w-3.5 h-3.5" />
        </button>

        {/* Eliminar */}
        <button
          onClick={onDelete}
          className="p-1.5 text-red-600 hover:bg-red-50 rounded transition-colors"
          title="Eliminar"
        >
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default ActivityRow;
